import React from 'react';
import { CGE } from "../../../../common/components/CGE";
import { decode_utf8, changeCurrancyFormat, getPageLayoutType, validateEmailFunc, getCurrentTime} from "../../../../common/utils/utilsFunc";
import { LiferayService } from "../../../../common/services/liferay/index";
import PaymentList from "../../../debt-current-overdue/components/PaymentList";
import { ClayRadio, ClayRadioGroup } from "@clayui/form";
import "../../styles/index.scss"
import AlertModal from "../../../../common/components/AlertModal";
import { useModal } from "@clayui/modal";
import { AccessTokenContext } from "../../../../common/context/AccessTokenProvider";
import { TOKEN_CAPTCHA_COOKIE_KEY,TOKEN_CAPTCHA_COOKIE_KEY_AUX,getCookie } from "../../../../common/utils/cookiesUtil";
import useCookie from '../../../../common/hooks/useCookie';

function PaymentDetail({ props }) {

  const [idCtaCto, setIdCtaCto] = React.useState();
  const [visibleModal, setVisibleModal] = React.useState(false);
  const [confirmModal, setConfirmModal] = React.useState(false);
  const [msgModal, setMsgModal] = React.useState();
  const [typePayment, setTypePayment] = React.useState();
  const [email, setEmail]  = React.useState();
  const [inputValidate, setInputValidate]  = React.useState(false);
  const [msgErrorValidate, setMsgErrorValidate] = React.useState();
  const [currentEntity, setCurrentEntity] = React.useState();
  const [typeDebt, setTypeDebt] = React.useState();
  const [verifReCaptcha, setVerifReCaptcha] = React.useState(false);
  const { observer, onClose } = useModal({
    onClose: () => {
        setVisibleModal(false);
        setInputValidate(false);
    },
});
  const { updateCookieState } = useCookie(TOKEN_CAPTCHA_COOKIE_KEY);

  const shouldDisableCupon = 
    props.responseDebtCc?.ultBoleta === "0" && 
    props.responseDebtCc?.antBoleta === "0" &&
    props.responseDebtCc?.terBoleta === "0";

  const FINTOC_DEFAULT_LOGO = "https://assets.fintoc.com/?img_name=combo_cl_light";
  const fintocPaymentEnabled = props.fintoc_payment_enabled !== "false";
  const fintocPaymentKey = props.fintoc_payment_key || "fintoc";
  const fintocPaymentText = props.fintoc_payment_text || "Paga con tu Banco";
  const fintocPaymentLogo = props.fintoc_payment_logo || FINTOC_DEFAULT_LOGO;
  const fintocCreateSessionEndpoint = props.fintoc_create_session_endpoint || "fintoc/create-session";

  const isFintocEntity = (entity) => {
    return entity?.key && entity.key.toLowerCase() === fintocPaymentKey.toLowerCase();
  };

  const paymentEntities = React.useMemo(() => {
    const currentEntities = props.entities || [];

    if (!fintocPaymentEnabled) {
      return currentEntities;
    }

    const normalizeFintocEntity = (entity = {}) => ({
      ...entity,
      key: entity.key || fintocPaymentKey,
      descripcion: fintocPaymentText,
      uriLogo: fintocPaymentLogo,
      disponible: entity.disponible !== false,
      isExternal: false,
    });

    const hasFintoc = currentEntities.some((entity) => isFintocEntity(entity));

    const normalizedEntities = hasFintoc
      ? currentEntities.map((entity) => isFintocEntity(entity) ? normalizeFintocEntity(entity) : entity)
      : [
          normalizeFintocEntity({
            key: fintocPaymentKey,
            disponible: true,
          }),
          ...currentEntities,
        ];

    const fintocEntities = normalizedEntities.filter((entity) => isFintocEntity(entity));
    const otherEntities = normalizedEntities.filter((entity) => !isFintocEntity(entity));

    return [
      ...fintocEntities,
      ...otherEntities,
    ];
  }, [props.entities, fintocPaymentEnabled, fintocPaymentKey, fintocPaymentText, fintocPaymentLogo]);

  React.useEffect(() => {
    const localCaptcha = getCookie(TOKEN_CAPTCHA_COOKIE_KEY_AUX);
    if(localCaptcha) {
      onChangeReCaptcha(localCaptcha);
    }
    
    const params = window.location.search;
    const paramsMethod = new URLSearchParams(params);
    const idCtaCtoLocal = paramsMethod.get("ctacto");
    const typeDebt =  paramsMethod.get("typeDebt");
    setTypeDebt(typeDebt);
    if (idCtaCtoLocal) {
      setIdCtaCto(idCtaCtoLocal);
    }
  }, []);

  React.useEffect(() => {
    if(props?.cleanCaptcha) {
      onChangeReCaptcha("");
    }
  },[props?.cleanCaptcha])

  React.useEffect(() => {
    if(idCtaCto){
      props.setLoading(true)
      props.dispatch({
        payload: ["OVIRTUAL", idCtaCto],
        type: props.ACTIONS.SET_JSON_DEBT,
      })
    }
  }, [idCtaCto])


function onChangeReCaptcha(value) {
  updateCookieState(value);
  if (value) {
      setVerifReCaptcha(true);
  }
  else {
      setVerifReCaptcha(false);
  }
}

  var panelActions =
    <div className="d-flex justify-content-center">
      <CGE.Button
        className="mb-4"
        label="Volver"
        onClick={() => { window.history.back() }}
        type="secondary"
      />
    </div>

    function handleButtonTicket() {
      let valueTicket = null;
      switch (props.valueRadio) {
        case "L" : {
          valueTicket = props.responseDebtCc?.ultBoleta
        }
        case "T" : {
          valueTicket = props.responseDebtCc?.terBoleta
        }
        case "A" : {
          valueTicket = props.responseDebtCc?.antBoleta
        }
        default: {
          valueTicket = valueTicket;
        }
      }
      if(!valueTicket){
        props.setGlobalAlert("Seleccione la boleta para emitir el cupón de pago.", "warning")

      } else if(!verifReCaptcha && !getPageLayoutType()){
        props.setGlobalAlert("Falta validar que no eres un Robot.", "warning")

      } else {
        props.setLoading(true)

        LiferayService.getCouponCc(props.base_url_api, [idCtaCto, props.valueRadio], props.codigo_empresa, props.url_ws_empresa, "").then((response) => {
          if (response?.code === 0) {
              let base64String = Buffer.from(response?.codCupon, "hex").toString("base64");
              let link = document.createElement('a');
              link.download = `CuponDePagos_${getCurrentTime()}.pdf`;
              link.href = 'data:application/octet-stream;base64,'+base64String;
              link.click();
          } else {
              props.setGlobalAlert(response.mensaje ? response.mensaje : decode_utf8(props.text_fetch_error),"warning", true, "Advertencia");
          }
          props.setLoading(false);
      })
      }
    }

    function funcClickButton(obj) {
      if(obj["enMantencion"]){
        props.setGlobalAlert(obj["descripcionMantencion"], "warning", true, "Advertencia")
      }else if (obj["isExternal"]) {
        window.open(` ${obj.externalURL}`, '_blank')
      } else {
        setVisibleModal(true)
        setConfirmModal(true)
        setMsgModal("Ingrese la dirección de email a la que desea que se envíe el comprobante")
        setCurrentEntity(obj)
      }
    }

    async function goToPayment() {
      if(email && !validateEmailFunc(email)){
        setInputValidate(true)
        setMsgErrorValidate("Debes ingresar un email válido")
        props.setGlobalAlert("Complete todos los campos obligatorios", "warning")

      } else if(email && validateEmailFunc(email)){
        setInputValidate(false)
        setMsgErrorValidate("")
        props.dispatch({
          payload: [idCtaCto, typeDebt === '2' ? props.responseDebtCc?.antBoleta : props.responseDebtCc?.ultBoleta],
          type: props.ACTIONS.SET_JSON_START_PAGO
        })

        if (isFintocEntity(currentEntity)) {
          props.setLoading(true)
          const payload = {
            ctacto: idCtaCto,
            cuentaContrato: idCtaCto,
            tipoDeuda: typeDebt === '2' ? 'VENCIDA' : 'ACTUAL',
            email: email,
            sociedad: props.codigo_empresa,
            canal: getPageLayoutType() ? 'ZOV' : 'URL'
          };

          try {
            const response = await LiferayService.createFintocCheckoutSession(
              props.base_url_api,
              fintocCreateSessionEndpoint,
              payload
            );

            if (response?.code === 0 && response?.redirectUrl) {
              window.open(response.redirectUrl, '_self')
            } else {
              props.setGlobalAlert(response?.message ? response.message : decode_utf8(props.text_fetch_error), "warning", true, "Advertencia")
              props.setLoading(false)
            }
          } catch (error) {
            props.setGlobalAlert(decode_utf8(props.text_fetch_error), "warning", true, "Advertencia")
            props.setLoading(false)
          }
        } else if (currentEntity.isExternal) {
          window.open(` ${currentEntity.externalURL}
        `, '_self')
        } else {
          window.open(` ${props.payment_url_api}payment/${currentEntity.key}?nrzas=${typeDebt === '2' ? props.deudaVencida.NRZAS :  props.deudaActual.NRZAS}&ctaCto=${idCtaCto}&debtValue=${typeDebt === '2' ? props.responseDebtCc?.antBoleta :  props.deudaActual.BETRW}&channel=${ getPageLayoutType() ? 'ZOV' : 'URL'}&company=${props.codigo_empresa === 'E200' ? 'CGE' : 'EDELMAG'}&email=${email}&calloutURL=${`${props.liferay_base_url}${getPageLayoutType() ? 'group/guest/comprobante-de-pago-priv' : 'comprobante-de-pago'}`}
          `, '_self')
        }
        onClose();
      } else {
        setInputValidate(true)
        setMsgErrorValidate("Debes ingresar un email válido")
        props.setGlobalAlert("Complete todos los campos obligatorios", "warning")
      }
    }

  return (
    <div className="cge-payment-detail">
      <CGE.Panel title={decode_utf8(props.titulo_detalle_de_cuenta)} footerContent={panelActions}>
        {props?.deudaActual?.BETRW ?
        <>
          <CGE.PanelSectionTicket title={decode_utf8(props.subtitulo_1_detalle_de_cuenta)}>
            <CGE.PanelContainer size="sm">
              <div className="row pb-2 ">
                    <div className="col-md-4">
                        <CGE.Text size="4" text={"N° Cliente: "} style={{ color: 'black' }} />
                    </div>
                    <div className="col-md-8">
                        <CGE.Text size="7" text={idCtaCto ? idCtaCto : ""} style={{ color: 'black' }} />
                    </div>
                </div>
            </CGE.PanelContainer>

            { getPageLayoutType() &&
              <CGE.PanelContainer size="sm">
              <div className="row pb-2 ">
                    <div className="col-md-4">
                        <CGE.Text size="4" text={"Nombre Cliente: "} style={{ color: 'black' }} />
                    </div>
                    <div className="col-md-8">
                        <CGE.Text size="7" text={props.responseDebtCc?.nomCliente ? props.responseDebtCc?.nomCliente : ""} style={{ color: 'black' }} />
                    </div>
                </div>
            </CGE.PanelContainer> }

            <CGE.PanelContainer size="sm">
              <div className="row pb-2 ">
                  <div className="col-md-4">
                      <CGE.Text size="4" text={"Dirección: "} style={{ color: 'black' }} />
                  </div>
                  <div className="col-md-8">
                      <CGE.Text size="7" text={props.state?.responseEntityPaid?.direccion ? props.state?.responseEntityPaid?.direccion : ""} style={{ color: 'black' }} />
                  </div>
              </div> 
            </CGE.PanelContainer>
            <CGE.Spacing type="md"/>
          </CGE.PanelSectionTicket>
          <CGE.PanelSectionTicket title={decode_utf8(props.subtitulo_2_detalle_de_cuenta)}>
            <div className="text-center">
              <CGE.Text  size="7" text={`Total a Pagar: ${typeDebt === '2'  ? changeCurrancyFormat(Number(props.responseDebtCc?.antBoleta)) : changeCurrancyFormat(Number(props.deudaActual.BETRW))}`} style={{ color: 'black', fontSize: '18px'}} />
              <CGE.Spacing type="md"/>
            </div>
            <div className="row">
              <div className="col-md-12 mb-3">
                  <CGE.Text size="7" text="Seleccione el tipo de pago en línea:" style={{ color: 'black' }} />
                  <CGE.Spacing type="sm" />
                <ClayRadioGroup
                  className="ClayRadioGrup"
                  inline
                  onSelectedValueChange={(value) => {
                    setTypePayment(value);
                  }}
                  selectedValue={typePayment}
                >
                </ClayRadioGroup>
              </div>
                <div className="col-md-12">
                  <div className="row">
                    {paymentEntities?.map(obj => {
                      return (
                        obj["disponible"] &&
                        <div className="col-md-3 text-center" key={obj["key"] || obj["descripcion"]}>
                        <a
                          className="cge-payment-option"
                          onClick={() => { funcClickButton(obj)}}
                          >
                            <div className="cge-payment-option__img-wrapper" style={{backgroundImage: `url(${obj["uriLogo"]})`}}>
                              <img src={obj["uriLogo"]} alt={obj["descripcion"]}/>
                            </div>
                            <CGE.Text size="8" text={obj["descripcion"]} style={{ color: 'black' }} />
                          </a>
                        </div>
                        )
                      })}
                  </div>
                </div> 
            </div>
          </CGE.PanelSectionTicket>
          <CGE.PanelSectionTicket title={decode_utf8(props.subtitulo_3_detalle_de_cuenta)}>
            <CGE.Text size="7" text="Seleccione la boleta para emitir el cupón de pago:" style={{ color: 'black' }} />
            <CGE.Spacing type="sm" />
            <ClayRadioGroup
              className="ClayRadioGrup cge-checkBox-ticket"
              inline
              onSelectedValueChange={(value) => {
                props.setValueRadio(value);
              }}
              selectedValue={props.valueRadio}
            >
              <ClayRadio className="color-black" label={`Última Boleta ${changeCurrancyFormat(Number(props.responseDebtCc?.ultBoleta))}`}  disabled={props.responseDebtCc?.ultBoleta === "0" }   value="L" />
              <ClayRadio label={`Boleta Anterior ${changeCurrancyFormat(Number(props.responseDebtCc?.antBoleta))}`} disabled={props.responseDebtCc?.antBoleta === "0"} value="A" />
              <ClayRadio label={`Tercera Boleta ${changeCurrancyFormat(Number(props.responseDebtCc?.terBoleta))}`} disabled={props.responseDebtCc?.terBoleta === "0"} value="T"/>
            </ClayRadioGroup>
            <CGE.Spacing type="md"/>
            {props.showWebContent && <PaymentList htmlValue={props.webContentHtml} />}  
            {shouldDisableCupon ? null : <>{!getPageLayoutType() &&
              <>
                <CGE.Spacing type="md"/>
                <CGE.FieldRecaptcha
                    onChange={onChangeReCaptcha}
                    sitekey={decode_utf8(props.api_key_recaptcha)}
                    horizontal={true}
                />
              </>
            }</>}
            <div className="col-md-12 d-flex justify-content-end">
            <CGE.Button
              disabled={shouldDisableCupon}
              label="Emitir Cupón de Pago"
              onClick={() => { handleButtonTicket()}}
              className="mb-4"
              size="sm"
            />
            </div>
          </CGE.PanelSectionTicket>
      </>
       : 
       props.showErrorMsg && (
        <>
          <div className="cge-altaSubscriptionConfirmation__icon">
            <p></p>
          </div>
          <CGE.Heading
              className="font-weight-normal text-justify"
              size="4"
              text={props.responseDebtCc?.mensaje ? props.responseDebtCc?.mensaje : decode_utf8(props.text_fetch_error)}
          />
       </>
       )
 
        }
        {visibleModal && (
                <AlertModal
                    titleModal="Atención"
                    msgModal={msgModal}
                    observer={observer}
                    onClose={onClose}
                    status={"info"}
                    funcClick={() => goToPayment()}
                    confirm={confirmModal}
                >
                  <>
                    <CGE.Spacing type="md"/>
                    <CGE.FormsField
                      labelName="Correo electrónico"
                      idFormElement="email"
                      handleChange={(e) => setEmail(e.target.value)}
                      typeFormElement="text"
                      horizontal={true}
                      typeElement="input"
                      value={email}
                      mandatoryElement={true}
                      hasError={inputValidate}
                      msgError={msgErrorValidate}
                    />
                  </>
                </AlertModal>
        )}
      </CGE.Panel>
    </div>
  )
}

export default PaymentDetail;
